import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GamesList } from "@/components/ui/GameList";
import { Loading } from "@/layouts/components";
import { useGetGamesQuery } from "@/store/api";
export var PublicGamesList = function (props) {
    var gameListGetState = useGetGamesQuery({ timeframe: props.timeFrame });
    return (_jsxs(_Fragment, { children: [gameListGetState.isSuccess && (_jsx(GamesList, { data: gameListGetState.data.items })), _jsx(Loading, { isActive: gameListGetState.isLoading, loadingKey: "gameList" })] }));
};
